import { HiSun, HiMoon } from "react-icons/hi";
import PropTypes from "prop-types";
import { useTheme } from "../../contexts/ThemeContext";
import { motion } from "framer-motion";

const ThemeToggle = ({ isOnHeroSection = false }) => {
  const { isDarkMode, toggleTheme } = useTheme();

  return (
    <motion.button
      onClick={toggleTheme}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      className={`
        relative p-2 rounded-lg transition-all duration-300 
        ${
          isOnHeroSection
            ? isDarkMode
              ? "text-yellow-400 hover:text-yellow-200 hover:bg-white/10"
              : "text-gray-500 hover:text-gray-400 hover:bg-white/10"
            : isDarkMode
            ? "text-yellow-400 hover:text-yellow-300 hover:bg-gray-800"
            : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
        }
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
        dark:focus:ring-offset-gray-800
      `}
      aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
      title={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
    >
      <motion.div
        initial={false}
        animate={{
          scale: isDarkMode ? 1.1 : 1,
        }}
        transition={{
          type: "spring",
          stiffness: 200,
          damping: 10,
        }}
      >
        {isDarkMode ? (
          <HiMoon className="w-5 h-5" aria-hidden="true" />
        ) : (
          <HiSun className="w-5 h-5" aria-hidden="true" />
        )}
      </motion.div>

      {/* Subtle background animation */}
      <motion.div
        className={`
          absolute inset-0 rounded-lg opacity-0 
          ${isDarkMode ? "bg-yellow-400" : "bg-blue-500"}
        `}
        whileHover={{ opacity: 0.1 }}
        transition={{ duration: 0.2 }}
      />
    </motion.button>
  );
};

ThemeToggle.propTypes = {
  isOnHeroSection: PropTypes.bool,
};

export default ThemeToggle;
